import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from '@mui/material'
import { AutoCoderFrameworkSuggestion } from '../../types/gotypes'

interface SuggestionsTableProps {
  suggestions: AutoCoderFrameworkSuggestion[]
}

const SuggestionsTable: React.FC<SuggestionsTableProps> = ({ suggestions }) => {
  if (suggestions.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant='body2' color='text.secondary'>
          No suggestions found.
        </Typography>
      </Box>
    )
  }

  return (
    <TableContainer sx={{ maxHeight: 'calc(100vh - 300px)' }}>
      <Table size='small' stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 150, minWidth: 150 }}>Variable</TableCell>
            <TableCell sx={{ width: 150, minWidth: 150 }}>Code</TableCell>
            <TableCell sx={{ width: 200, minWidth: 200 }}>Explanation</TableCell>
            <TableCell>Source Text Excerpt</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {suggestions.map((suggestion, index) => (
            <TableRow key={`${suggestion.match?.code}-${index}`} hover>
              <TableCell>{suggestion.match?.name || ''}</TableCell>
              <TableCell>{suggestion.match?.code || ''}</TableCell>
              <TableCell sx={{ fontSize: '0.85rem' }}>{suggestion.match?.explanation || ''}</TableCell>
              <TableCell sx={{ fontSize: '0.85rem', fontStyle: 'italic' }}>
                {suggestion.matching_text || ''}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default SuggestionsTable
